export default __webpack_public_path__ + "static/media/blue-tick.aac4ee69.svg";